import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../../assets/logo.svg";

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const close = () => setMenuOpen(false);
  const isHome = location.pathname === "/";

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? "bg-brand shadow-[0_2px_20px_rgba(0,40,73,0.25)]"
          : "bg-brand/95 backdrop-blur-md"
      }`}
    >
      <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" onClick={close}>
          <img src={logo} alt="PIA" className="h-9" />
        </Link>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-1">
          {[
            { to: "/", label: "Início" },
            { to: "/payment", label: "Pagamentos" },
            { to: "/instituicoes", label: "Instituições" },
            { to: "/contact", label: "Contacto" },
          ].map(({ to, label }) => (
            <Link
              key={to}
              to={to}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${
                location.pathname === to
                  ? "bg-white/15 text-white"
                  : "text-white/70 hover:text-white hover:bg-white/10"
              }`}
            >
              {label}
            </Link>
          ))}
        </nav>

        {/* CTA buttons */}
        <div className="hidden md:flex items-center gap-3">
          <a
            href={isHome ? "/register" : "/access-user"}
            className="text-white/70 hover:text-white text-sm font-medium px-3 py-2 transition-colors"
          >
            Entrar
          </a>
          <Link
            to="/register"
            className="bg-blue-light hover:bg-blue transition-colors text-white text-sm font-semibold px-5 py-2.5 rounded-full"
          >
            Começar Grátis
          </Link>
        </div>

        {/* Hamburger */}
        <button
          aria-label={menuOpen ? "Fechar menu" : "Abrir menu"}
          onClick={() => setMenuOpen(!menuOpen)}
          className={`hamburger md:hidden w-6 h-0.5 bg-white relative cursor-pointer ${menuOpen ? "active" : ""}`}
        />
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="md:hidden bg-brand border-t border-white/10 px-6 py-6 flex flex-col gap-2">
          {[
            { to: "/", label: "Início" },
            { to: "/payment", label: "Pagamentos" },
            { to: "/instituicoes", label: "Instituições" },
            { to: "/contact", label: "Contacto" },
          ].map(({ to, label }) => (
            <Link key={to} to={to} onClick={close} className="text-white/80 hover:text-white font-medium py-2.5 border-b border-white/5">
              {label}
            </Link>
          ))}
          <div className="pt-4 flex flex-col gap-3">
            <a href="/access-user" className="text-center text-white/70 py-2.5 font-medium">Entrar</a>
            <Link to="/register" onClick={close} className="bg-blue-light text-white text-center py-3 rounded-full font-semibold">
              Começar Grátis
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
